import { Controller } from '@hotwired/stimulus'
import { Navigation, Pagination, Swiper } from 'swiper'

export default class extends Controller {
    connect() {
        const topDevList = document.querySelector('.top-developer__list')
            if (topDevList) {
            Swiper.use([Navigation, Pagination])
            this.swiperDeveloper = new Swiper(topDevList, {
                slidesPerView: "auto",
                pagination: {
                    el: '.num-arr__numbers',
                    type: "fraction",
                },
                navigation: {
                    nextEl: ".num-arr__right",
                    prevEl: ".num-arr__left",
                },
            });
            }
    }

    disconnect() {
        this.swiperDeveloper.destroy()
    }
}
